import {
  GET_MARKETPLACES_BEGIN, GET_MARKETPLACES_SUCCESS, GET_MARKETPLACES_FAILURE,
} from './../constants/ActionTypes'

const initialState = {
  marketplaces: [],
  marketplaceError: null,
  loadingMarketplaces: false
}

const ReducerMarketplace = (state = initialState, { payload, type }) => {
  switch (type) {

    case GET_MARKETPLACES_BEGIN: {
      return {
        ...state,
        marketplaces: [],
        marketplaceError: null,
        loadingMarketplaces: true,
      }
    }
    case GET_MARKETPLACES_SUCCESS: {
      return {
        ...state,
        marketplaces: payload.response,
        marketplaceError: null,
        loadingMarketplaces: false,
      }
    }
    case GET_MARKETPLACES_FAILURE: {
      return {
        ...state,
        marketplaces: [],
        marketplaceError: payload,
        loadingMarketplaces: false,
      }
    }

    default: return state
  }
}

export default ReducerMarketplace